import type { ReactNode } from 'react';

import { useReveal } from '../hooks/useReveal';

interface RevealProps {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article';
}

/** Wraps content in the shared fade-up. Inert when motion is reduced. */
export function Reveal({ children, className, as: Tag = 'div' }: RevealProps) {
  const { ref, visible } = useReveal<HTMLDivElement>();

  return (
    <Tag
      ref={ref}
      className={className ? `reveal ${className}` : 'reveal'}
      data-visible={visible}
    >
      {children}
    </Tag>
  );
}
